import { coreTextLimits } from "@ibada/shared-types/common"

/**
 * The `Workspace.name` / `displayName` column limit (both VarChar(60)) — one name field seeds both, so the
 * form has to cap at the column rather than let the write truncate silently.
 *
 * What used to live here — a zod mirror of the draft body and a sessionStorage key for the capability token —
 * went with the pre-auth draft flow. Church details are now sent straight from an authenticated request, so
 * there is nothing to stage and nothing to carry across a page load.
 */
export const CHURCH_NAME_MAX_LENGTH = coreTextLimits.workspaceName
